<template>
  <div  style="">
      <div v-if="$store.state.auth==false" class="pa-2">
         <v-row no-gutters align="center" justify="center">
            <v-col cols="6">
                 <p>To place an order, you'll need to be a Zaastry- Reward member</p>

          <router-link to="/user/create" style="text-decoration:none;color:black">
              <p class="text-h4 font-weight-bold">Join now</p>
          </router-link>
          <router-link to="/login" style="text-decoration:none;color:black">
              <p class="text-h4 font-weight-bold">Sign in</p>
          </router-link>
            </v-col>
         </v-row>
      </div>
      <div  v-else>
         <pay  />
      </div>
  </div>
</template>

<script>
import Pay from '../views/About.vue'
export default {
   components:{
       Pay
   },
   data(){
       return {
           pay:false
       }
   },
   mounted(){
       console.log("auth",this.$store.state.auth)
   }
}
</script>

<style>

</style>